// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
/* eslint ember/no-classic-classes:"off" */
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
const ServiceConfigs = {
  feedback_premium: {
    signupForwardTarget: 'feedback',
    iconLarge: 'icon-null-state-feedback',
    requirePaymentMethodOnSignup: true,
    allowActivation: true
  },
  loyalty: {
    signupForwardTarget: 'customers.rewards',
    iconLarge: 'icon-null-state-loyalty',
    externalActivationUrl: '/dashboard/customers/loyalty',
    requirePaymentMethodOnSignup: true,
    allowForMultiunit: true
  },
  marketing: {
    signupForwardTarget: 'marketing',
    iconLarge: 'icon-null-state-marketing',
    externalActivationUrl: '/dashboard/customers/marketing',
    requirePaymentMethodOnSignup: true,
    allowForMultiunit: true
  },
  appointments: {
    iconLarge: 'icon-null-state-appointments_subscription',
    externalActivationUrl: '/appointments/',
    signupExternalTarget: '/appointments/dashboard',
    allowActivation: true,
    allowForMultiunit: true
  },
  register_pro: {
    signupForwardTarget: 'team',
    iconLarge: 'icon-null-state-register-pro',
    allowForMultiunit: true
  },
  dearsystems: {
    name: 'DEAR'
  },
  deputy: {
    name: 'Deputy'
  },
  ecwid: {
    name: 'Ecwid'
  },
  freshkds: {
    name: 'Fresh KDS'
  },
  homebase: {
    name: 'Homebase'
  },
  humanity: {
    name: 'Humanity'
  },
  intrakr: {
    name: 'Intrakr Inventory'
  },
  invoiceasap: {
    name: 'InvoiceASAP'
  },
  ip_commerce: {
    name: 'Commerce Sync'
  },
  kashoo_square: {
    name: 'Kashoo Cloud Accounting'
  },
  marketman: {
    name: 'MarketMan Professional'
  },
  one_up: {
    name: 'ONE UP'
  },
  peachworks: {
    name: 'Whisk by PeachWorks'
  },
  peachworks_inventory: {
    name: 'PeachWorks Inventory'
  },
  shipstation: {
    name: 'ShipStation Bronze'
  },
  shogo: {
    name: 'Shogo'
  },
  shopseen: {
    name: 'Shopseen'
  },
  simple_order: {
    name: 'Simple Order'
  },
  shopventory: {
    name: 'Shopventory'
  },
  taxjar: {
    name: 'TaxJar'
  },
  tsheets: {
    name: 'TSheets'
  },
  when_i_work: {
    name: 'When I Work'
  },
  zoho_books: {
    name: 'Zoho Books'
  },
  zoho_books_monthly: {
    name: 'Zoho Books'
  },
  zoho_invoice: {
    name: 'Zoho Invoice'
  },
  zoho_subscriptions_standard: {
    name: 'Zoho Subscriptions'
  }
};
export default ApplicationSerializer.extend({
  primaryKey: 'id',
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if ('entity' in payload) {
      payload = payload.entity;
    }
    if ('entities' in payload) {
      payload = payload.entities;
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  },
  normalize(modelClass, hash) {
    const serviceConfig = ServiceConfigs[hash.service] || ServiceConfigs[hash.product_group];
    if (serviceConfig) {
      hash.signup_forward_target = serviceConfig.signupForwardTarget;
      hash.icon_large = serviceConfig.iconLarge;
      hash.allow_for_multiunit = serviceConfig.allowForMultiunit;
      hash.signup_external_target = serviceConfig.signupExternalTarget;
      hash.require_payment_method_on_signup = serviceConfig.requirePaymentMethodOnSignup;
      hash.external_activation_url = serviceConfig.externalActivationUrl;
      hash.allow_activation = serviceConfig.allowActivation;
      hash.translations = true;
    } else {
      hash.translations = false;
    }

    // Response doesn't include `service_end_date` upon activate,
    // but EmberData won't null it out unless the field exists.
    if (!Object.prototype.hasOwnProperty.call(hash, 'service_end_date')) {
      hash.service_end_date = null;
    }
    return this._super(modelClass, hash);
  }
});